import React from 'react';

import {
    Modal,
    Form,
    Button,
    Row,
    Col,
    message
} from 'antd'

import {
    _getSupplierList,
    _postAddVmSupplier
} from '../../services'

import SupplierAutocomplete from '../supplier/autocomplete'

class NewVmSupplierModal extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            supplierList: [],

            supplierEmail: '',
            supplierCompanyName: '',
        }
    }

    render() {
        return (
            <Modal
                title="New VM Supplier"
                visible={this.props.newVmSupplierModalVisible}
                onCancel={() => this.props.closeVmSupplierModal()}
                footer={false}
            >
                {this.renderForm()}
            </Modal>
        )
    }

    componentDidMount() {
        _getSupplierList()
        .then(_suppliers => {
            console.log({_suppliers})
            this.setState({
                supplierList: _suppliers.data
            })
        })
    }

    renderForm = () => {

        const { getFieldDecorator } = this.props.form;
        
        const layout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
        };

        const tailLayout = {
            wrapperCol: { offset: 10, span: 4 },
        };

        return (
            <Form 
            {...layout}
            onSubmit={this.handleSubmit}>

                <Form.Item label="Select Supplier">
                    {getFieldDecorator('HELLO', {
                        value: this.state.supplierId,
                        initialValue: this.state.supplierId,
                        rules: [{ required: true }],
                    })(
                        <SupplierAutocomplete 
                            onSelect={this.handleSupplierSelect}
                            />
                    )}
                </Form.Item>

                {this.renderInfo({colName: 'Email', value: this.state.supplierEmail})}
                {this.renderInfo({colName: 'Company', value: this.state.supplierCompanyName})}


                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>

            </Form>
        )
    }

    renderInfo = ({colName, value}) => {
        return (
            <Row gutter={8}>
                <Col span={6}>{colName}</Col>
                <Col span={18}>{value}</Col>
            </Row>
        )
    }

    handleInputChange = (value, name, index) => {
        this.setState({
            treatmentGroups: this.state.treatmentGroups.map((v,i) => {
                if (i===index) {
                    v[name]=value
                }
                return v
            })
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
          if (!err) {
            const { supplierId } = this.state
            _postAddVmSupplier({supplierId})
            .then(_supplier => {
                console.log({_supplier})
                message.success('Add success!')
                this.props.closeVmSupplierModal()
            })
          
          }

        })

    }

    handleSupplierSelect = (value) => {
        console.log({value})
        const [ supplierId, supplierCompanyName, supplierEmail ] = value.split('~!@');
        console.log({supplierId})
        this.setState({
            supplierId,
            supplierEmail,
            supplierCompanyName
        })
    }

}

export default Form.create()(NewVmSupplierModal)


// WEBPACK FOOTER //
// ./src/components/vm-supplier/modal.js